module.exports = __webpack_public_path__ + "assets/img/btn-view-info-647c4158.png";